export const buildVehicles = (vehicles) => vehicles.map((vehicle => buildVehicle(vehicle)))

export const buildVehicle = (vehicle) => ({
    ...vehicle,
    owner: Array.isArray(vehicle.owner) ? vehicle.owner[0] : {}
});